/**
 * useTaskStatus — polling declarativo do status de geração (plano SPA, §2.4).
 * Substitui os setInterval de 3s espalhados por 17 templates: o TanStack
 * Query para sozinho quando o estado é terminal.
 */

import { useQuery } from '@tanstack/react-query'
import { ApiError } from '../api/http'
import {
  ESTADOS_TERMINAIS,
  statusTask,
  type StatusTask,
  type TipoTask,
} from '../api/tasks'

export const INTERVALO_POLLING_MS = 3000

export function useTaskStatus(tipo: TipoTask, id: number) {
  return useQuery<StatusTask, Error>({
    queryKey: ['task-status', tipo, id],
    queryFn: () => statusTask(tipo, id),
    refetchInterval: (query) => {
      const dados = query.state.data
      if (dados && ESTADOS_TERMINAIS.has(dados.estado)) return false
      // 404/422: recurso sumiu ou tipo errado — parar de martelar
      if (query.state.error instanceof ApiError) return false
      return INTERVALO_POLLING_MS
    },
    retry: (contagem, erro) => {
      if (erro instanceof ApiError && [401, 404, 422].includes(erro.status))
        return false
      return contagem < 3
    },
  })
}
